import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import { NAMESPACE as PARENT_NAMESPACE } from "../constants";
export const NEW_PROJECT = {
    Id: 0,
    Name: "",
    Created: 0,
    Updated: 0,
    WorkSpaceId: 0,
    Description: ""
};
export const requiredFields = ["Name", "WorkSpaceId"];
export const NAMESPACE = "projectEditor";
export const FULL_NAMESPACE = createNamespace(PARENT_NAMESPACE, NAMESPACE);
export { PARENT_NAMESPACE as PAGE_NAMESPACE };
